import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Alert,
  Box,
  Button,
  Collapse,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useDemoAppContext } from '../../pages/demo/DemoAppContext';
import './TrackContainer.css';
import TrackTrimmer from './TrackTrimmer';

const TrackContainer = () => {
  const [trackId, setTrackId] = useState<string>('');
  const [isResponseExpanded, setIsResponseExpanded] = useState(false);
  const [response, setResponse] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const { client, clientId } = useDemoAppContext();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setResponse(null);

    const response = await client.POST('/track-fetch', {
      body: {
        clientId,
        format: 'mp3:128',
        trackId: parseInt(trackId),
      },
    });

    if (response.error) {
      setError(response.error ?? 'An error occurred');
      return;
    }

    if (response.data) {
      setResponse(response.data);
    }
  };

  return (
    <Paper elevation={3} className="track-fetch-paper">
      <Typography variant="h5" component="h2" gutterBottom>
        Track Player (POST /track-fetch)
      </Typography>
      <form onSubmit={handleSubmit}>
        <Box className="track-fetch-container">
          <TextField
            fullWidth
            label="Track ID"
            variant="outlined"
            value={trackId}
            onChange={(e) => {
              setTrackId(e.target.value);
            }}
            required
          />

          <Button
            fullWidth
            variant="contained"
            type="submit"
            disabled={client.getToken() === ''}
            className="track-fetch-button"
          >
            Fetch Track
          </Button>
        </Box>
      </form>

      {error && (
        <Alert severity="error" className="track-fetch-error">
          {error}
        </Alert>
      )}

      {response && (
        <Box className="track-fetch-response">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h6" gutterBottom>
              Response:
            </Typography>
            <IconButton
              onClick={() => {
                setIsResponseExpanded(!isResponseExpanded);
              }}
            >
              {isResponseExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Box>
          <Collapse in={isResponseExpanded}>
            <Paper variant="outlined" className="track-fetch-response-paper">
              <pre className="track-fetch-response-pre">
                {JSON.stringify(response, null, 2)}
              </pre>
            </Paper>
          </Collapse>
          <Box className="track-fetch-player">
            <TrackTrimmer
              trackUrl={response.trackUrl}
              trackId={parseInt(trackId)}
              title={response.title}
              artist={response.artist}
              release={response.release}
              artworkUrl={response.artworkUrl}
            />
          </Box>
        </Box>
      )}
    </Paper>
  );
};

export default TrackContainer;
